import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingNeppanFormModel } from "@/components/features/settings/site-controller/model/neppan/type";
import type { SiteControllerSettingNeppanFormModelMethodsType } from "@/components/features/settings/site-controller/model/neppan/use-case/use-create-model/methods";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	setUpRoomPriceByChillnn: SiteControllerSettingNeppanFormModel["ViewModel"]["setUpRoomPriceByChillnn"]; //
	onSetSetUpRoomPriceByChillnn: SiteControllerSettingNeppanFormModelMethodsType["siteControllerSettingNeppanFormModelMethods"]["onSetSetUpRoomPriceByChillnn"];
};

export const SettingsSiteControllerNeppanSetUpRoomPriceByChillnn = ({
	setUpRoomPriceByChillnn,
	onSetSetUpRoomPriceByChillnn,
}: Props) => {
	return (
		<QuestionForMain
			guide="ねっぱんではなく、CHILLNNの管理画面上で部屋の料金を管理するための設定です。ここにチェックを入れると、ねっぱんの料金設定は反映されなくなります。"
			required={false}
			title={"CHILLNNで部屋料金を管理しますか？"}
			belowTitleChildren={
				<p className="text-sm text-error-600">
					CHILLNNで作成したプランをねっぱんと料金連携している場合、「CHILLNNで部屋の料金を管理する」に変更すると、
					<br />
					該当プランの料金設定は無効になり自動的に非公開になります。
					<br />
					変更後、あらためて料金を設定し直した上で、公開に戻してください。
				</p>
			}
			inputChildren={
				<CheckboxField
					label="CHILLNNで部屋の料金を管理する"
					value={setUpRoomPriceByChillnn?.value ?? false}
					errorMessage={setUpRoomPriceByChillnn?.error}
					handleChange={onSetSetUpRoomPriceByChillnn}
				/>
			}
		/>
	);
};

SettingsSiteControllerNeppanSetUpRoomPriceByChillnn.displayName = "SettingsSiteControllerNeppanSetUpRoomPriceByChillnn";
